import { createContext, useContext, useLayoutEffect, useCallback, useState, useMemo, useRef, useReducer, useEffect } from 'react'
import usePerformance from './performance'

const LoadingContext = createContext();

export default function useLoading() {
    return useContext(LoadingContext)
}

export function LoadingProvider({ children }) {
    // console.log('loading Provider Render')
    const suspend = useRef(false); //needed separate ref for suspend because there's no way to test the pending/fulfilled status of a promise
    const promise = useRef(null); 
    const error = useRef(null); 
    const [mounted, setMounted] = useState(false); //not clear whether this is even needed
    
    // useLayoutEffect(() => {
    //     //a bit hacky, but I needed way to trigger another render once everything had initially mounted  
    //     setMounted(true)
    // }, [])
    
    //tracking stats, optional 
    usePerformance();

    const status = useCallback((phase) => {
        // console.log('status callback:');
        if (phase===2 && error.current) {
            console.log(`error: `, error.current);
            console.log('throwing error')
            throw error.current
        }
        if (phase === 1 && suspend.current) {
            if (!(promise.current instanceof Promise)) {
                error.current = new Error('Suspend triggered without a promise')
                suspend.current = false;
            }
            else {
                console.log(`suspend: `, suspend.current);
                console.log('throwing promise')
                throw promise.current
            }
        }
    }, [])

    return (
        <LoadingContext.Provider value={{
            suspend,
            status,
            promise,
            error,
            mounted,
        }}>
            {children}
        </LoadingContext.Provider>
    )
}
